import logger from 'src/utils/logger/logger';
export default function detection (agent) {
  let comp_agent = agent.indexOf("tizen") != -1;
  if (comp_agent) {
    logger.info ("[tizen detection] detected");
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/tizen/detection.js